module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightsnowshowers-27b8fe24f85a3792bc34929e46175dae.png";